import { Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { faArrowDown, faArrowUp, faBarsStaggered } from '@fortawesome/pro-regular-svg-icons';

import { SurveyPositioningService } from '../../../services/survey-positioning.service';
import { MoveBulkToPositionComponent } from '../move-bulk-to-position/move-bulk-to-position.component';

@Component({
  selector: 'empathy-positioning-actions',
  templateUrl: 'positioning-actions.component.html',
  styleUrls: ['positioning-actions.component.scss']
})
export class PositioningActionsComponent {
  isFirst = input<boolean>();
  isLast = input<boolean>();
  questionId = input.required<string>();

  faArrowUp = faArrowUp;
  faArrowDown = faArrowDown;
  faBarsStaggered = faBarsStaggered;

  private dialog = inject(MatDialog);
  private surveyPositioningService = inject(SurveyPositioningService);

  onMoveUp(): void {
    this.surveyPositioningService.move('up', this.questionId());
  }

  onMoveDown(): void {
    this.surveyPositioningService.move('down', this.questionId());
  }

  onJumpTo(): void {
    const questionIdSet = new Set<string>([this.questionId()]);
    const { affectedQuestions, affectedBlocks } = this.surveyPositioningService.getAllDependenciesOfQuestions(questionIdSet);
    const affectedElements = !!affectedQuestions?.size || !!affectedBlocks?.size;

    this.dialog.open(MoveBulkToPositionComponent, { data: { questionsToMoveIds: Array.from(questionIdSet), affectedElements } });
  }
}
